import { render, staticRenderFns } from "./FundPassVerifyModal.vue?vue&type=template&id=37aae7a8&scoped=true"
import script from "./FundPassVerifyModal.vue?vue&type=script&lang=js"
export * from "./FundPassVerifyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aae7a8",
  null
  
)

export default component.exports